<template>
  <article :id="productStory.id" :qaid="productStory.id">
    <div v-if="productStory.assetId" class="mb-4">
      <image-component
        :qaid="`${productStory.id}-image`"
        :breakpoint-map="breakpointConfig"
        :asset-id="productStory.assetId"
        transformation="pad"
        :alt-text="getAltText"
      />
    </div>
    <div>
      <pdl-heading v-if="productStoryHeading" size="md" :level="3" :qaid="`${productStory.id}-heading`" class="mb-1">
        {{ productStoryHeading }}
      </pdl-heading>
      <p v-if="productStory.body" :qaid="`${productStory.id}-body`" class="mb-1">
        {{ productStory.body }}
      </p>
      <pdl-link
        v-if="hasLink"
        standalone
        icon="chevron_right"
        icon-right
        :href="linkUrl"
        v-bind="dynamicAttrs"
        :qaid="`${productStory.id}-product-story-link`"
      >
        {{ productStory.link.linkName }}
      </pdl-link>
    </div>
  </article>
</template>

<script>
import {mapState} from 'vuex';
import ImageComponent from '@/components/ImageComponent.vue';
import {PdlLink} from '@pedal/pdl-link';
import {PdlHeading} from '@pedal/pdl-section-header';

export default {
  components: {
    ImageComponent,
    PdlLink,
    PdlHeading,
  },
  props: {
    productStory: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },
  data() {
    return {
      breakpointConfig: {
        xsWidth: 800,
        smWidth: 800,
        mdWidth: 800,
        mlWidth: 800,
        lgWidth: 800,
        xlWidth: 800,
        xxlWidth: 800,
      },
    };
  },
  computed: {
    ...mapState('backend', ['encodedContextPath']),

    hasLink() {
      return !!this.productStory?.link;
    },
    productStoryHeading() {
      if (this.productStory.title) {
        return this.productStory?.title;
      }
      return this.productStory?.displayName;
    },
    booleanConversions() {
      return {
        target: this.productStory?.link?.target.toLowerCase() === 'newwindow',
      };
    },
    dynamicAttrs() {
      return {
        ...(this.booleanConversions.target && {target: '_blank', rel: 'noopener'}),
        ...(this.productStory?.link?.video && {['data-video']: ''}),
      };
    },
    linkUrl() {
      if (this.productStory?.link?.url?.includes('//')) {
        return this.productStory?.link?.url;
      }
      return `${this.encodedContextPath}${this.productStory?.link?.url}`;
    },
    getAltText() {
      return this.productStoryHeading;
    },
  },
};
</script>
